import { observable } from "mobx";
import { Type } from "class-transformer";
import ExemptionCancellationActionResponse from "./exemptionCancellationActionResponse";
import ExemptionChangeActionResponse from "./exemptionChangeActionResponse";
import ExemptionDeletionActionResponse from "./exemptionDeletionActionResponse";
import ExemptionDetailAccessActionResponse from "./exemptionDetailAccessActionResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ExemptionPermittedActionsResponse {
  @observable
  @Type(() => ExemptionDetailAccessActionResponse)
  exemptionDetailAccess!: ExemptionDetailAccessActionResponse;

  @observable
  @Type(() => ExemptionChangeActionResponse)
  exemptionChange!: ExemptionChangeActionResponse;

  @observable
  @Type(() => ExemptionCancellationActionResponse)
  exemptionCancellation!: ExemptionCancellationActionResponse;

  @observable
  @Type(() => ExemptionDeletionActionResponse)
  exemptionDeletion!: ExemptionDeletionActionResponse;
}
